export const pointreport = {
  namespaced: true,
  state: {
    selectedPoint:null,
    loadingAsync: false,
    syncProgress: { total: 0, done: 0 },
    loadingReport: false
  },
  getters: {
  },
  actions: {
    
  },
  mutations: {
    setSelectedPoint(state,point){
      state.selectedPoint = point
    },

    setLoadingAsync(state, loading) {
      state.loadingAsync = loading
    },

    setSyncProgress(state, progress) {
      state.syncProgress = progress
    },

    setLoadingReport(state, loading) {
      state.loadingReport = loading
    }
  }
}